import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SPA-aware Google Analytics 4 tracker.
// Fires a 'page_view' event on every route change so all React Router
// navigations are counted (the base gtag config sets send_page_view: false).
export default function Analytics() {
  const location = useLocation();
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    if (!gaId || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
      page_location: window.location.href,
      page_title: document.title,
      send_to: gaId,
    });
  }, [location]);
  return null;
}

// Helper to fire custom events from anywhere in the app.
// Usage: trackEvent('signup', { method: 'email' })
export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag !== "function") return;
  try { window.gtag("event", name, params); } catch { /* noop */ }
};
